import { render, staticRenderFns } from "./CausesRejectionsCategories.vue?vue&type=template&id=0e1c4815"
import script from "./CausesRejectionsCategories.vue?vue&type=script&lang=js"
export * from "./CausesRejectionsCategories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports